import { setLocationLabel } from 'src/features/locationSearchSlice';
import { showLoader } from 'src/features/loaderSlice';
import type { AppDispatch } from 'src/store/store';

/** Persist search locality for site breadcrumb, then show the global route loader. */
export const beginLocationSearchSiteNavigation = (
  dispatch: AppDispatch,
  locality?: string
): void => {
  if (locality?.trim()) {
    dispatch(setLocationLabel(locality.trim()));
  }
  dispatch(showLoader());
};
